export const csvEscape = (value = "") => {
  const v = String(value ?? "");
  if (/[",\n\r]/.test(v)) return `"${v.replaceAll('"', '""')}"`;
  return v;
};

export const getPromoStoreOrderItems = (order = {}) => {
  const directItems = Array.isArray(order?.items) ? order.items : [];
  const rawItems = Array.isArray(order?.rawPayload?.line_items) ? order.rawPayload.line_items : [];
  const source = directItems.length ? directItems : rawItems;

  return source.map((item = {}) => {
    const quantity = Number(item?.quantity ?? item?.qty ?? 0) || 0;
    const unitPrice = Number(item?.price ?? item?.unitPrice ?? item?.unit_price ?? 0) || 0;
    const lineTotal = Number(item?.total ?? item?.lineTotal ?? item?.line_total ?? quantity * unitPrice) || 0;

    const variationFromList = Array.isArray(item?.variation)
      ? item.variation
          .map((v) => `${v?.name || v?.attribute || ""}: ${v?.option || v?.value || ""}`.trim())
          .filter(Boolean)
          .join(" | ")
      : "";
    const variationFromMeta = Array.isArray(item?.meta_data)
      ? item.meta_data
          .map((meta) => `${meta?.key || ""}: ${meta?.value || ""}`.trim())
          .filter(Boolean)
          .join(" | ")
      : "";

    return {
      id: item?.id ?? null,
      productId: item?.product_id ?? item?.productId ?? item?.productID ?? "",
      variationId: item?.variation_id ?? item?.variationId ?? item?.variationID ?? "",
      productName: item?.name || item?.product_name || item?.title || "Unnamed item",
      sku: item?.sku || item?.SKU || "",
      quantity,
      unitPrice,
      lineTotal,
      variation: variationFromList || variationFromMeta || "",
      decoration: item?.decorationSummary || item?.decoration_summary || "",
      raw: item,
    };
  });
};

export const normalizeReportGroupValue = (value = '') => String(value ?? '').trim().toLowerCase().replace(/\s+/g, ' ');


export const isLikelyPromoStoreTestOrder = (order = {}) => {
  const candidates = [
    order?.customerName,
    order?.customer_name,
    order?.CustomerName,
    order?.customerEmail,
    order?.customer_email,
    order?.billing?.email,
    order?.billing_email,
    order?.rawPayload?.billing?.email,
    order?.rawPayload?.billing?.first_name,
    order?.rawPayload?.billing?.last_name,
    order?.rawPayload?.customer_note,
  ]
    .filter(Boolean)
    .map((v) => String(v).toLowerCase());

  return candidates.some((value) =>
    value.includes("test") ||
    value.includes("qa") ||
    value.includes("dummy") ||
    value.includes("sample") ||
    value.includes("@example.com")
  );
};
